import { i18nextContainer } from 'shared/configs/i18n/config'
import { z } from 'zod'

export const regularLoginSchema = z.object({
  email: z
    .email({
      error: i18nextContainer.t('auth:new_login.validation.email_invalid')
    })
    .min(1, {
      error: i18nextContainer.t('auth:new_login.validation.email_required')
    }),

  password: z.string().min(1, {
    error: i18nextContainer.t('auth:new_login.validation.password_required')
  }),
  remember_me: z.boolean()
})
